export const CHANNEL_DASHBOARD = 'dashboard';
export const REFERENCES_GENERATED = 'references:generated:';
